import { useEffect, useRef } from 'react';
import { signInForSSE } from 'services/auth.service';
import { subscribeConnect } from 'services/sse.service';
import { useAppSelector } from 'store/store-hooks';

export const useAppSseUpload = () => {
  const uploadingFiles = useAppSelector((state) => state.app__filesUpload.uploadingFiles);
  const eventSrcRef = useRef<EventSource | null>(null);
  const isSse = useRef(false);

  const start = async () => {
    if (isSse.current) return;
    isSse.current = true;
    const token = await signInForSSE().then((res) => res.data.token);
    eventSrcRef.current = await subscribeConnect(token);
  };

  const stop = () => {
    eventSrcRef.current?.close();
    eventSrcRef.current = null;
    isSse.current = false;
  };

  useEffect(() => {
    if (uploadingFiles.length) start();
    else stop();
  }, [uploadingFiles.length]);
};
